import React from 'react'
import cn from '../../../../lib/utils/cn'

interface FilterButton<T extends string> {
	label: string
	value: T
}

interface FilterButtonsProps<T extends string> {
	buttons: FilterButton<T>[]
	activeFilter: T
	onFilterChange: (filter: T) => void
	counts?: Record<T, number>
}

const FilterButtons = <T extends string>({
	buttons,
	activeFilter,
	onFilterChange,
	counts,
}: FilterButtonsProps<T>) => {
	return (
		<div className="flex flex-wrap gap-2 w-full">
			{buttons.map(({ label, value }) => {
				const count = counts?.[value]
				const showBadge = value !== 'all' && count !== undefined && count > 0

				return (
					<button
						key={value}
						onClick={() => onFilterChange(value)}
						className={cn(
							'px-3 py-2 text-xs rounded-lg transition-colors relative',
							'bg-background-light dark:bg-background-dark border border-stroke-light dark:border-stroke-light-dark text-text-main dark:text-background-light',
							activeFilter === value &&
								'border-accent text-white bg-accent dark:bg-accent dark:border-accent dark:text-text-main-dark',
						)}
					>
						{label}
						{showBadge && (
							<span
								className={cn(
									'absolute rounded-full bg-accent-light border border-accent min-w-4 h-4 -top-2 -right-2 text-[11px] text-text-main flex items-center justify-center',
									String(count)?.length > 2 && 'px-0.5',
								)}
							>
								{count}
							</span>
						)}
					</button>
				)
			})}
		</div>
	)
}

export default FilterButtons
